import React from 'react';


interface IComponentProps {
  data: any;
}
const TimePeriod: React.FC<IComponentProps> = (props) => {
  const { data } = props

  return (
      <>
        {
          data?.rental_day_limit?.map((item: any, index: number) => {
            return <div>
              {item.date_ranges?.join('-') + ` ${item.limit}天起租`}
            </div>
          })
        }
      </>
  );
};

export default TimePeriod;
